import React, { useState } from "react";
import styles from "./TopBar.module.css";
import { NavLink } from "react-router-dom";
import { ALL_PRODUCTS, SOLID_FUEL_BOILERS, PELLET_BOILERS, INDUSTRIAL_BOILERS, BOILERS, BURNERS, ACCESORIES, PROMOTIONS, allProducts } from "../../API/ProductsAPI";

const TopBar = (props) => {
  const isMobile = (window.innerWidth <= 768) ? true : false;

  const [query, setQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setQuery(value);
    const filtered = allProducts
      .filter((product) => product.name.toLowerCase().includes(value))
      .map((product) => ({
        id: product.id,
        image: product.image,
        name: product.name,
        price: product.price,
      })
      );
    setFilteredProducts(filtered);
  };

  const handleCategoryNavlink = () => {
    props.setActiveCategory(ALL_PRODUCTS)
    props.setProducts(allProducts);
  }

  const getNameByType = () => {
    switch (props.activeCategory) {
      case SOLID_FUEL_BOILERS:
        return 'Cazane pe combustibil solid';
      case PELLET_BOILERS:
        return 'Centrale pe peleți';
      case INDUSTRIAL_BOILERS:
        return 'Centrale și cazane industriale';
      case BOILERS:
        return 'Boilere, acumulatoare și puffere';
      case BURNERS:
        return 'Arzătoare pe peleți';
      case ACCESORIES:
        return 'Accesorii';
      case PROMOTIONS:
        return 'Promoții';
      default:
        return null
    }
  }

  return (
    <div className={styles.container}>
      {/* Breadcrumb */}
      <div className={styles.breadcrumb}>
        <NavLink to='/' className={styles.category} onClick={handleCategoryNavlink}>Produse</NavLink>
        <span className={styles.separator}>/</span>
        {props.activeCategory === ALL_PRODUCTS ||
          <>
            <NavLink to='/' className={styles.category}>{getNameByType()}</NavLink>
            <span className={styles.separator}>/</span>
          </>
        }
        <span className={styles.productName}>{props.name}</span>
      </div>

      {isMobile || <div className={styles.searchBar}>
        {/* Search Input */}
        <div className={styles.searchInput}>
          <input
            type="text"
            placeholder="Caută un produs..."
            value={query}
            className={styles.input}
            onChange={handleSearch} />
          <button type="button" className={styles.searchButton}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              width="14"
              height="14"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="4"
                d="M21 21l-4.35-4.35m1.4-4.65a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </button>
          {query && (
            <div className={styles.resultsContainer}>
              {filteredProducts.map((product, index) => (
                <NavLink to={`/product/${product.id}`} key={index} className={styles.resultItem}>
                  <img src={product.image} alt={product.name} className={styles.resultImage} />
                  <div>
                    <h4 className={styles.resultName}>{product.name}</h4>
                    <p className={styles.resultPrice}>{product.price} RON</p>
                  </div>
                </NavLink>
              ))}
              {filteredProducts.length === 0 && (
                <p className={styles.noResults}>Nu s-au găsit rezultate.</p>
              )}
            </div>
          )}
        </div>
      </div>}
    </div>
  );
};

export default TopBar;
